import React, { useState } from 'react';
import { removeUserFromStorage, setUserInfoOnLocalStorage} from '../../utils/users';
import { encrypty } from '../../utils/helpers';

import {
  Button,
  Col,
  Row,
  Spin,
  Form,
  Input,
  notification,
  Card,
} from 'antd';
import { useNavigate } from 'react-router-dom';

import './AuthenticateAs.scss';
import '../login/LoginComponent/LoginComponent'; 

import {
  get,
  post,
  isSuperAgentError,
  RequestWrapper,
  ResponseWrapper,
} from '../../dataSource/requests';

type TForm = {
  adminPassword: string;
  userFederalRegistration: string;
};

const AuthenticateAs = (): JSX.Element => {
  const navigate = useNavigate();
  const [formInstance] = Form.useForm();
  const [, setResponseValue] = useState([]);

  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState<any | null>(null);

  const searchUser = async (): Promise<void> => {
    const federalRegistration = formInstance.getFieldValue('userFederalRegistration');

    if (!federalRegistration) {
      notification.warning({
        message: 'Atenção',
        description: 'Informe o CPF ou CNPJ do usuário.',
      });
      return;
    }

    setLoading(true);
    setUserData(null);

    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;

    const requestReference: RequestWrapper = get({
      url: `/auth/findUserByFederalRegistration/${federalRegistration}`,
      frontConfigs: {
        navigateFunction: navigate,
      },
    });

    try {
      response = await requestReference;
    } catch (error: unknown) {
      if (isSuperAgentError(error)) {
        responseError = error.response;
      }
    }
   const responseCode = response?.body?.code ?? responseError?.body?.code;

    switch (true) {
      case (response != null && response.body?.code === 1014): {
        setUserData(response.body.customer);
        notification.success({
          message: 'Usuário encontrado',
        });
        break;
      }
    case (responseCode != null && responseCode in AUTHENTICATE_AS_ERROR_MESSAGES): {
        notification.error({
                message: 'Erro',
                description: AUTHENTICATE_AS_ERROR_MESSAGES[responseCode],
        });
        break;
    }

      default: {
        notification.error({
          message: 'Erro',
          description: 'Não foi possível localizar o usuário informado.',
        });
        break;
      }
    }

    setLoading(false);
  };

  const AUTHENTICATE_AS_ERROR_MESSAGES: Record<number, string> = {
        [-4001]: 'Sessão expirada. Faça login novamente.',
        [-4003]: 'Você não tem permissão para realizar esta operação.',
        [-1016]: 'Senha do administrador inválido.',
        [-1012]: 'Usuário não está ativado. Entre em contato com o suporte.',
        [-1013]: 'Administrador não está ativado. Entre em contato com o suporte.',
        [-1028]: 'Para cooperado, o CPF/CNPJ deve ser informado.',
        [-1021]: 'CPF/CNPJ não encontrado na base de dados.',
        [-1047]: 'O CPF/CNPJ informado não pertence a um cooperado. É permitido supervisionar apenas cooperados.',
        [-1046]: 'Usuário tem mais de um registro ativo.',
        [-1041]: 'CPF/CNPJ não registrado no Campo Digital.',
    };

  const authenticateAs = async (values: TForm): Promise<void> => {
    if (!userData) {
      notification.warning({
        message: 'Atenção',
        description: 'Busque o usuário antes de continuar.',
      });
      return;
    }

    setLoading(true);

    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;

    const requestReference: RequestWrapper = post({
      url: '/auth/authenticateAs',
      params:{
        adminPassword: values.adminPassword,
        userFederalRegistration: values.userFederalRegistration,
        appVersion: '1.34.0',
        device: 'WEB',
      },
      frontConfigs: {
        navigateFunction: navigate,
      },
    });

    try {
      response = await requestReference;
    } catch (error: unknown) {
      if (isSuperAgentError(error)) {
        responseError = error.response;
      }
    }
    const responseCode = response?.body?.code ?? responseError?.body?.code;


    switch (true) {
      case (response != null && response.body?.code === 1002): {
        notification.success({
            message: 'Sucesso',
            description: 'Login realizado com sucesso.',
        });
        console.log('authenticateAs response.body:', response.body);
        setResponseValue(response?.body);
        removeUserFromStorage();
        loginFunction(response.body);
        break;
        }

        case (responseCode != null && responseCode in AUTHENTICATE_AS_ERROR_MESSAGES): {
            notification.error({
                    message: 'Erro',
                    description: AUTHENTICATE_AS_ERROR_MESSAGES[responseCode],
            });
            break;
        }

      default: {
        notification.error({
          message: 'Erro',
          description: 'Não foi possível realizar o login.',
        });
        break;
      }
    }

    setLoading(false);
  };

  const loginFunction = (
      response: {
        name: string;
        bp: string;
        id: number;
        token: string;
        role: {
          name: string;
          type: string;
          permissions: any;
        };
        userMail: any;
      }): void => {
      // Encrypty and save user ID in local storage
      // localStorage.setItem('user_id', encrypty(response.data.id));
  
      // Save user data in the local storage
      setUserInfoOnLocalStorage(response);
  
      // Encrypty and save data in local storage
      localStorage.setItem('user_name', response.name ? encrypty(response.name) : encrypty('-'));
      localStorage.setItem('user_bp', response.bp ? encrypty(response.bp) : encrypty(''));
      localStorage.setItem('user_id', response.id ? encrypty(`${response.id}`) : encrypty(''));
      localStorage.setItem('cooper_token', encrypty(response.token));
      localStorage.setItem('user_role', encrypty(response.role.name));
      localStorage.setItem('user_type', encrypty(response.role.type));
      localStorage.setItem('user_permissions', encrypty(JSON.stringify(response.role.permissions)));
  
      localStorage.setItem('user_mail', encrypty(JSON.stringify(response.userMail)));

console.log('cooper_token raw:', localStorage.getItem('cooper_token'));
console.log('user_role raw:', localStorage.getItem('user_role'));
console.log('user_permissions raw:', localStorage.getItem('user_permissions'));

//debugger;
        navigate('/', { replace: true });
          window.location.reload();
      // Change page
    //  navigate('/');
    };

  return (
    <div className="AuthenticateAs">
      <Spin spinning={loading} tip="Processando...">
        <Row className="title-container">
          <Col>
            <span className="page-title">Logar como usuário</span>
          </Col>
        </Row>

        <Form
          layout="vertical"
          form={formInstance}
          onFinish={authenticateAs}
          className="form-container"
        >
          <Row gutter={[16, 24]}>
            <Col xs={24} lg={12}>
              <Form.Item
                label="CPF ou CNPJ do usuário"
                name="userFederalRegistration"
                rules={[{ required: true, message: 'Campo obrigatório' }]}
              >
                <Input placeholder="Digite o CPF ou CNPJ" />
              </Form.Item>
            </Col>

            <Col xs={24} lg={4}>
              <Form.Item label=" ">
                <Button block onClick={searchUser}>
                  Buscar usuário
                </Button>
              </Form.Item>
            </Col>
          </Row>

          {userData && (
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Card className="user-card">
                  <p><strong>Nome:</strong> {userData.name}</p>
                  <p><strong>BP:</strong> {userData.bp}</p>
                </Card>
              </Col>
            </Row>
          )}

          <Row gutter={[16, 24]}>
            <Col xs={24} lg={12}>
              <Form.Item
                label="Senha do administrador"
                name="adminPassword"
                rules={[{ required: true, message: 'Informe sua senha' }]}
              >
                <Input.Password />
              </Form.Item>
            </Col>

            <Col xs={24} lg={6}>
              <Form.Item label=" ">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn-submit"
                  block
                  disabled={!userData}
                >
                  Logar como
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </div>
  );
};


export default AuthenticateAs;
